'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n0% { opacity: 0; }\n50% { opacity: 1; }\n'], ['\n0% { opacity: 0; }\n50% { opacity: 1; }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 250px;\n  max-width: 280px;\n  background: white;\n  text-align: center;\n  box-sizing: border-box;\n  margin: 0 auto;\n  animation: ', ' .5s linear 1 forwards;\n'], ['\n  width: 100%;\n  height: 250px;\n  max-width: 280px;\n  background: white;\n  text-align: center;\n  box-sizing: border-box;\n  margin: 0 auto;\n  animation: ', ' .5s linear 1 forwards;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fadeinout = (0, _styledComponents.keyframes)(_templateObject);
var Wrapper = _styledComponents2.default.div(_templateObject2, fadeinout);
exports.default = Wrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-modern-datepicker/build/elements/Wrapper.js
// module id = 96
// module chunks = 0